import { URL_CONFIG } from '../utils/url.const'

export const SHARE_URLS = {
  facebook: 'https://www.facebook.com/sharer/sharer.php',
  twitter: 'https://twitter.com/intent/tweet',
  youtubeEmbed: 'https://www.youtube.com/embed/',
  youtubeWatch: 'https://www.youtube.com/watch?v=',
}

export const buildShareUrls = {
  facebook: (url: string, title: string) =>
    `${SHARE_URLS.facebook}?u=${encodeURIComponent(url)}&title=${encodeURIComponent(title)}`,

  twitter: (url: string, title: string) =>
    `${SHARE_URLS.twitter}?url=${encodeURIComponent(url)}&text=${encodeURIComponent(title)}`,

  youtubeEmbed: (videoId: string) =>
    `${SHARE_URLS.youtubeEmbed}${encodeURIComponent(videoId)}`,

  youtubeWatch: (videoId: string) =>
    `${SHARE_URLS.youtubeWatch}${videoId}`,

    copy: (url?: string | null) => {
      if (url) return url
      if (typeof window !== 'undefined') return window.location.href
    return ''
    }
}

export type ShareNetwork = keyof typeof buildShareUrls

export const routes = {
  take_5_daily: `${URL_CONFIG.TAKE_5_DAILY}`,
  search: '/search',
};

export const queryParams = {
  search: 'search',
  q: 'q',
};
